
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-their-own-terms",
      function () {
        return require("private-next-pages/on-their-own-terms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-their-own-terms"])
      });
    }
  